module.exports = __webpack_public_path__ + "static/c9-693c8393a18b6ee4279215150a8ef9a0.png";